import styled from "styled-components";

export const ColumnSpacer = styled.div`
	margin-right: ${(p) => String(p.column * 2)}px;
`;
